<template>
    <div>
        <v-data-table v-if="!showEmail" disable-initial-sort
                      :headers="headers" :items="items" class="elevation-1 gru-table fixed-header"
                      :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
            <template slot="headers">
                <tr>
                    <th v-for="header in headers" :width="header.width">
                        <div :style="header.headerStyle">
                            {{$t(header.text)}}
                        </div>
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr :key="props.index">
                    <td class="text-xs-center">{{ props.index+1 + parseInt(pagination.page-1) *
                        parseInt(pagination.rowsPerPage)}}
                    </td>
                    <td class="text-xs-left">
                        <input type="text" class="tableInput" v-model="props.item.documentCode"/>
                    </td>
                    <td class="text-xs-left">
                        <input type="text" class="tableInput" v-model="props.item.documentName"/>
                    </td>
                    <!--td class="text-xs-left">{{ getStatusName(props.item.status) }}</td-->
                    <td align="center">
                        <i-upload label=""
                                  v-model="props.item.documentId"
                                  file-type="attach" :multifile="false"
                                  accept=".docx"
                                  :key="'document_'+props.index+props.item.procDocId"
                                  :name="'document_'+props.index+props.item.procDocId"
                                  :data-vv-as="$t('lang.procedure.document')"
                                  :error-messages="errors.first('document')"
                        />
                    </td>
                    <td align="center">
                        <v-btn depressed outline icon fab dark color="red" small @click="deleteDocument(props.index)"
                               title="Clear">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <div style="text-align: right">
            <v-spacer></v-spacer>
            <v-btn dark class="info" @click="addDocument" width="200">
                {{ $t('lang.common.add') }}
            </v-btn>
            <v-btn dark class="primary" @click="onSave" width="200">
                {{ $t('lang.common.save') }}
            </v-btn>
            <v-btn @click="onCancel" width="200">
                {{$t("lang.common.cancel")}}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {CrudService} from "@/services";
    import {message} from "@/shared/message";
    import Validator from "../../../../public/js/validator";
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import IUpload from "../../../components/form/Upload";

    export default {
        name: "procedure-file-document",
        components: {IUpload},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            procedure: null,
            showList: true,
            sortField: "teacherName",
            orderBy: "asc",
            headers: [
                {
                    text: "lang.common.no",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "5%"
                },
                {
                    text: "lang.procedure.documentCode",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "documentCode",
                    width: "10%"
                },
                {
                    text: "lang.procedure.documentName",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "documentName",
                    width: "20%"
                },
                {
                    text: "lang.procedure.documentTemplate",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "teacherId",
                    width: "20%"
                },
                {
                    text: "lang.common.clear",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "procDocInId",
                    width: "10%"
                }
            ],
            items: [],
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            editingItem: null,
            editorData: "",
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
            },
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                // The configuration of the editor.
            },
            showEmail: false,
        }),

        watch: {},

        created() {
        },
        methods: {
            viewProcedureDocument(item) {
                this.procedure = item;
                this.getDocument();
            },

            getDocument() {
                axios.post(process.env.VUE_APP_API_URL + "/procedure/inputDocument/list", this.procedure).then(
                    data => {
                        this.$nextTick(
                            () => {
                                this.items = data;
                                this.pagination.totalItems = this.items.length;
                                console.log(this.editor);
                            }
                        )
                    }
                )
            },

            addDocument() {
                let ob = {
                    "procedureId": this.procedure.procedureId,
                    "documentCode": "",
                    "documentName": "",
                    "documentId": null,
                    "status": 1
                }
                this.items.push(ob);
            },

            deleteDocument(index) {
                this.items.splice(index, 1);

            },
            onSave() {
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i].documentName == null || this.items[i].documentName.trim() == "") {
                        message.error("Document name is not allow null");
                        return;
                    }
                    if (this.items[i].documentCode == null || this.items[i].documentCode.trim() == "") {
                        message.error("Document code is not allow null");
                        return;
                    }

                }
                axios.post(process.env.VUE_APP_API_URL + "/procedure/inputDocument/saveAll?procedureId=" + this.procedure.procedureId, this.items).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                            this.getDocument();
                            this.onCancel();
                        } else {
                            message.error(data.description);
                        }
                    }
                )

            },

            onCancel() {
                this.$emit("cancel");
            }

        }
    };
</script>